import React, { useEffect } from 'react';
import { EditContactInfoForm } from './EditContactInfoForm';
import { Error } from '@pec/aion-ui-components/components/Error';
import { fetchTrainee, updateTrainee } from 'features/trainee/slice';
import { getOptionsIfNeeded } from '@pec/aion-ui-core/actions/options';
import { ITrainee } from '@pec/aion-ui-core/interfaces/trainee';
import { Loading } from '@pec/aion-ui-components/components/Loading';
import { parse } from '@pec/aion-ui-core/helpers/querystring';
import { useAppDispatch, useTypedSelector } from 'app/reducer';
import { useHistory, useLocation } from 'react-router-dom';
import { UserPrompt } from './UserPrompt';

export const EditContactInfo: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { isFetching: isFetchingTrainee, error: traineeError, trainee, count: traineeCount } = useTypedSelector(
    state => state.trainee
  );
  const { userInfo, isFetching: isFetchingUserInfo, error: userInfoError } = useTypedSelector(state => state.userInfo);

  const isFetching = isFetchingTrainee || isFetchingUserInfo;
  const error = traineeError || userInfoError;

  const onSubmit = async (editContactInfoForm: ITrainee) => {
    await dispatch(updateTrainee(editContactInfoForm));

    const userReferredByCbt = parse(location.search).from === 'eLearning/Student/';
    userReferredByCbt ? window.location.assign('/eLearning/Student/') : history.push('/contact-info');
  };

  useEffect(() => {
    dispatch(getOptionsIfNeeded());
  }, [dispatch]);

  useEffect(() => {
    if (userInfo) {
      dispatch(fetchTrainee(userInfo.userId));
    }
  }, [dispatch, userInfo]);

  return !isFetching ? (
    trainee ? (
      <EditContactInfoForm onSubmit={onSubmit} initialValues={trainee} trainee={trainee} location={location} />
    ) : trainee === undefined ? (
      <UserPrompt isRegistered={traineeCount === 1} />
    ) : (
      error && <Error />
    )
  ) : (
    <Loading />
  );
};
